export function formatBytes(bytes: number | string | null | undefined): string {
  const n = Number(bytes || 0);
  if (!Number.isFinite(n) || n <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let idx = 0;
  let val = n;
  while (val >= 1024 && idx < units.length - 1) {
    val = val / 1024;
    idx += 1;
  }
  const fixed = idx === 0 ? 0 : val < 10 ? 2 : 1;
  return `${val.toFixed(fixed)} ${units[idx]}`;
}

const MIME_TYPE_EXT_MAP: Record<string, string> = {
  'application/pdf': 'pdf',

  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/gif': 'gif',

  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',

  'application/vnd.ms-excel': 'xls',
  'application/vnd.ms-excel.sheet.macroenabled.12': 'xlsm',
  'application/vnd.ms-excel.template.macroenabled.12': 'xltm',
  'application/vnd.ms-excel.sheet.binary.macroenabled.12': 'xlsb',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'xltx',

  'text/plain': 'txt',
  'text/csv': 'csv',
  'text/tab-separated-values': 'tsv',

  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/vnd.openxmlformats-officedocument.presentationml.template': 'potx',
  'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'pptm',

  'application/vnd.oasis.opendocument.text': 'odt',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',
  'application/vnd.oasis.opendocument.presentation': 'odp',

  'application/zip': 'zip',
  'application/x-zip-compressed': 'zip',

  'application/octet-stream': 'bin',
};

const GOOGLE_APPS_EXT_MAP: Record<string, string> = {
  'application/vnd.google-apps.document': 'gdoc',
  'application/vnd.google-apps.spreadsheet': 'gsheet',
  'application/vnd.google-apps.presentation': 'gslides',
  'application/vnd.google-apps.drawing': 'gdraw',
  'application/vnd.google-apps.form': 'gform',
  'application/vnd.google-apps.script': 'gscript',
};

export function getExtension(
  name: string | null | undefined,
  mimeType: string | null | undefined,
): string {
  const n = String(name || '').trim();

  const dot = n.lastIndexOf('.');
  if (dot > 0 && dot < n.length - 1) {
    const ext = n.slice(dot + 1).toLowerCase();
    if (ext.length <= 10) return ext;
  }

  const mt = String(mimeType || '').toLowerCase();

  if (MIME_TYPE_EXT_MAP[mt]) return MIME_TYPE_EXT_MAP[mt];
  if (GOOGLE_APPS_EXT_MAP[mt]) return GOOGLE_APPS_EXT_MAP[mt];
  if (mt.startsWith('application/vnd.google-apps.')) return 'gdoc';

  return '-';
}
